import Http from "@/commons/Http";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";

export default {

    async showPdf(url, data = null, method = 'POST', contentType = 'text/plain'){

        const config = {
            responseType: 'blob',
            timeout : 0,
            headers: {"Content-Type": contentType}
        };

        let promise;
        if(method === 'POST'){
            promise = Http.post(url, data, config);
        }else{
            promise = Http.get(url, config);
        }

        return promise.then(response => {
            const pdf = new Blob([response], {type: "application/pdf"});
            this.open(pdf);
        }).catch(e => {
            e.text().then(erro => {
                const error = JSON.parse(erro);
                ToastMessageBusiness.showError(error.message);
                if(error.field){
                    ToastMessageBusiness.showError(error.field);
                }
                throw error;
            });
        });

    },

    open(blob) {
        const fileURL = URL.createObjectURL(blob);
        return  window.open(fileURL, '', "toolbar=no,scrollbars=yes,resizable=no,width=1000,height=600");
    },

}